import Base from 'src/storage/base';
import constants from 'src/constants';
import { validateObj } from 'src/helpers';

class AdminNotificationModel extends Base {
  id = 'AdminNotificationModel';
  defaultState = () => {
    const reminders = this.defaultReminderData();
    return {
      change: false,
      reminders,
      editing: JSON.parse(JSON.stringify(reminders))
    };
  };

  apiConfig = {
    detail: {
      url: 'admin/reminder/detail',
      validation: {},
      cancellable: true
    },
    save: {
      url: 'admin/reminder/save',
      validation: {},
      cancellable: true
    }
  };

  defaultReminderData = () => {
    return Array.from({ length: constants.general.adminReminderNum }, (a, v) => {
      return {
        id: v + 1,
        text: '',
        timeNumber: '',
        timeUnit: 'minutes',
        types: [],
        active: false
      };
    });
  };

  onLoad = () => {
    this.api('detail', {}, (err, data) => {
      let reminders = this.defaultReminderData();
      if (data?.length) {
        reminders = reminders.map((item) => data.find((i) => i.id === item.id) || item);
      }
      this.setState({ reminders, editing: JSON.parse(JSON.stringify(reminders)), change: false });
    });
    return false;
  };

  saveData = () => {
    const editing = model.state.editing;
    const invalid = { length: 0 };
    editing.forEach((item) => {
      if (!item.active) return;
      invalid[item.id] = validateObj(item, {
        text: ['required'],
        timeNumber: ['required'],
        types: ['array', 'required']
      });
      invalid.length += invalid[item.id].length;
    });

    if (invalid.length > 0) {
      return this.setInvalidApi('save', { reminders: { ...invalid }, length: 1 });
    }
    this.api('save', { reminders: editing }, (err, data) => {
      if (!err) {
        this.setState({
          reminders: data,
          editing: JSON.parse(JSON.stringify(data)),
          change: false
        });
      }
    });
  };
}

const model = new AdminNotificationModel();
export default model;
